import { useMutation } from 'react-query';
import { UpdateAccountType } from '../api/updateAccount.types';
import { updateAccount } from '../api/updateAccount';

export const useUpdateAccount = () =>
    useMutation<{}, Error, UpdateAccountType, unknown>(['updateAccount'], (data) =>
        updateAccount(data)
    );
